import { render } from "./TermsOfServicePage.vue?vue&type=template&id=132b2a6d&scoped=true"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=js"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=js"

import "./TermsOfServicePage.vue?vue&type=style&index=0&id=132b2a6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132b2a6d"]])

export default __exports__